import { Component } from "@angular/core";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { Toast, ToastPackage, ToastrService } from "ngx-toastr";
import { IconComponent } from "@bitwarden/web-vault/app/components/icon/icon.component";

@Component({
  selector: "app-guide-success-toast",
  templateUrl: "./guide-success-toast.component.html",
  standalone: false,
  host: {
    "(click)": "tapToast()",
    "(mouseenter)": "stickAround()",
    "(mouseleave)": "delayedHideToast()",
    "[class]": "toastClasses",
    "[@flyInOut]": "_state",
    "[style.display]": "displayStyle",
  },
  animations: [
    trigger("flyInOut", [
      state("inactive", style({ opacity: 0 })),
      state("active", style({ opacity: 1 })),
      state("removed", style({ opacity: 0 })),
      transition("inactive => active", animate("{{ easeTime }}ms {{ easing }}")),
      transition("active => removed", animate("{{ easeTime }}ms {{ easing }}")),
    ]),
  ],
  preserveWhitespaces: false,
})
export class GuideSuccessToastComponent extends Toast {}
